import { type OrganizationBilling } from '../entity/api/organization-billing';
import { PlanFeature } from '../entity/api/plan';
import { hasOrgFeature } from './subscription';

export function parseCreditData(available?: number, total?: number, extraCredits?: number) {
  const totalCreditsRaw = total ?? 0;
  const availableCreditsParsed = available ?? 0;
  const extraCreditsParsed = extraCredits ?? 0;

  const totalCreditsWithExtra = totalCreditsRaw + extraCreditsParsed;
  const usedCredits = totalCreditsRaw - availableCreditsParsed;

  const usedPercentage =
    totalCreditsWithExtra > 0
      ? Math.max(0, Math.min(100, Math.round((usedCredits / totalCreditsWithExtra) * 100)))
      : 0;
  const remainingPercentage = 100 - usedPercentage;

  return {
    total: totalCreditsRaw,
    available: availableCreditsParsed,
    used: Math.max(totalCreditsRaw - availableCreditsParsed, 0),
    usedPercentage,
    remainingPercentage,
  };
}

export function getOrgCredit(organization?: OrganizationBilling) {
  const hasEnabledArticles = hasOrgFeature(organization, PlanFeature.EnabledArticles);
  const hasEnabledProducts = hasOrgFeature(organization, PlanFeature.EnabledProducts);
  const isProductOnlyPlan = hasEnabledProducts && !hasEnabledArticles;

  if (isProductOnlyPlan) {
    return parseCreditData(
      organization?.aiSubCredits ?? 0,
      organization?.features?.monthlyProductCredits ?? 0
    );
  }

  return parseCreditData(
    organization?.plan?.planCreditCount ?? 0,
    organization?.plan?.baseCreditsPerMonth ?? 0,
    organization?.plan?.extraCreditCount ?? 0
  );
}

/**
 * @deprecated since 09/03/2026, use getOrgCredit instead based on plan and handle legacy cases
 */
// export function getOrgCreditData(organization?: {
//   currentPlanRecurring?: OrganizationBilling['currentPlanRecurring'];
//   features?: {
//     monthlyProductCredits: OrganizationBilling['features']['monthlyProductCredits'];
//     yearlyProductCredits: OrganizationBilling['features']['yearlyProductCredits'];
//   };
//   plan?: {
//     baseCreditsPerMonth?: number | null;
//     planCreditCount?: number | null;
//     extraCreditCount?: number | null;
//     paymentCycle?: SubscriptionPaymentCycle | null;
//   } | null;
//   aiSubCredits: OrganizationBilling['aiSubCredits'];
// }) {
//   // LEGACY: this is part of the old system, 09-02-2026
//   let cycle = organization?.currentPlanRecurring ?? SubscriptionPaymentCycle.Month;
//   let monthlyCredits = organization?.features?.monthlyProductCredits ?? 0;
//   let yearlyCredits = organization?.features?.yearlyProductCredits ?? 0;
//   let subCredits = organization?.aiSubCredits ?? 0;

//   // we know we have a valid plan since we have always some base
//   // we keep the previous for legacy purposes
//   if (organization?.plan?.baseCreditsPerMonth != null) {
//     cycle = organization.plan.paymentCycle ?? cycle;
//     monthlyCredits = organization.plan.baseCreditsPerMonth ?? 0;
//     yearlyCredits = monthlyCredits * 12;
//     subCredits = organization.plan.planCreditCount ?? 0;
//   }

//   // we might have extra credits, lets add those
//   if (organization?.plan?.extraCreditCount != null) {
//     subCredits += organization.plan.extraCreditCount;
//   }

//   const totalCreditsRaw = cycle === SubscriptionPaymentCycle.Month ? monthlyCredits : yearlyCredits;
//   return parseCreditData(subCredits, totalCreditsRaw);
// }
